import { createFileRoute } from '@tanstack/react-router';
import { OnboardingPage } from '../../features/merchant-onboarding/OnboardingPage.jsx';

export const Route = createFileRoute('/_app/merchants/onboarding/')({ component: OnboardingPage });
